import React from 'react';

const PHKPensiun = () => {
  return (
    <h1>PHK / Pensiun</h1>
  );
};

export default PHKPensiun;





